
import React from 'react';
import { cn } from '@/lib/utils';
import { ChevronDown } from 'lucide-react';
import { CustomSelectContext } from './CustomSelectContext';

interface CustomSelectTriggerProps {
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

export const CustomSelectTrigger = React.forwardRef<HTMLButtonElement, CustomSelectTriggerProps>(({
  className,
  onClick,
  style,
  children
}, ref) => {
  const { isOpen, setIsOpen } = React.useContext(CustomSelectContext);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClick?.(e);
    setIsOpen(!isOpen);
  };

  return (
    <button
      ref={ref}
      type="button"
      className={cn(
        "flex h-8 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      onClick={handleClick}
      style={style}
    >
      {children}
      <ChevronDown className="h-4 w-4 opacity-50" />
    </button>
  );
});

CustomSelectTrigger.displayName = "CustomSelectTrigger";
